<template>
  <div>
    <el-upload
        ref="directUpload"
        action="#"
        :limit="1"
        :file-list="fileList"
        :show-file-list="showFileList"
        :http-request="uploadRequest"
        :before-upload="beforeUpload"
        :on-remove="handleRemove"
        :accept="accept"
        :on-exceed="handleExceed"
    >
      <div
          :style="{ width: width, height: height }"
          class="upLoad-pic-box">
        <div
            class="flex-center-row img-box"
            :style="{ width: width, height: height }"
            v-if="imgUrl">
          <img class="img" :src="imgUrl" alt="image">
          <div :class="['upload-mask', 'upload-mask-bgColor']">
            <i class="el-icon-delete delete-icon"
               @click.stop="handleRemove()"></i>
          </div>
        </div>
        <div
            v-else
            class="img-box"
            :style="{ width: width, height: height }">
          <img v-if="defaultImgUrl" class="img" :src="defaultImgUrl" alt="add">
          <i v-else class="el-icon-plus"></i>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
/**
 * uploadedFileList: 回显数据
 * fileList: 文件列表 ---> [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]
 * hoverIndex: --->控制删除图标的显示
 * model: 文件类型 ---> 'img'||'video'
 * limit:文件数量限制
 * defaultImgUrl: 数据为空时显示的图片
 * isTinymce: 富文本中的直传组件需要传true
 * size: 文件大小 ----'1MB'||'1'(不传单位默认为字节)
 * showFileList: 展示文件列表，不展示预览
 * customFileType: 文件指定格式限制 ---> "['image/png','image/jpeg']"
 */
import {directFileFn, getDirectInfo, beforeUpload} from '@/utils/directFile';

export default {
  name: 'directUpload',
  props: {
    width: {type: String, default: '176px'},
    height: {type: String, default: '120px'},
    model: {type: String, default: ''},
    limit: {type: Number, default: 0},
    isTinymce: {type: Boolean, default: false},
    imgUrl: {type: String, default: () => ''},
    fileList: {type: Array, default: () => []},
    size: {type: String, default: ''},
    showFileList: {type: Boolean, default: false},
    customFileType: {type: Array, default: () => []},
    defaultImgUrl: {type: String, default: ''},
  },
  data() {
    return {
      uploadedFileList: this.fileList || [],
      fileTypeMaps: {
        img: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
        video: ['video/mp4'],
        default: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'video/mp4'],
      },
      hoverIndex: null, // 控制当前图片的删除图标的显示
      accept: null, // 文件类型
      allowTypes: [], //允许通过的类型
    };
  },
  watch: {
    fileList: {
      handler(newVal) {
        this.uploadedFileList = newVal;
        this.hoverIndex = null;
      },
      immediate: true,
    },
    model: {
      handler(newVal) {
        const types = this.fileTypeMaps[newVal] || this.fileTypeMaps.default;
        this.allowTypes = types;
        this.accept = types.join(',');
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeUpload(file) {
      return beforeUpload(file, this.customFileType, this.allowTypes, this.size);
    },
    async uploadRequest({file}) {
      // sts临时身份是否到了过期时间
      const stsItem = JSON.parse(localStorage.getItem('stsItem'));
      if (!(stsItem && stsItem.expirationTime > Date.now())) await getDirectInfo();

      try {
        const getFilePath = await directFileFn(file);
        this.$emit('update:imgUrl', getFilePath.url);
        this.$emit('success');
        this.$emit('clearValid');
      } catch (err) {
        console.log('捕获到错误:', err);
        debugger
        this.$message.error('上传失败,请重新上传');
      }
    },
    handleExceed(files) {
      const isValid = this.beforeUpload(files[0]);
      if (!isValid) return false;

      this.$refs.directUpload.handleStart(files[0]); // 开始处理新的文件
      this.$refs.directUpload.submit(); // 手动上传
    },
    handleRemove() {
      this.$emit('update:imgUrl', '');
    },
  },
};
</script>
<style lang="scss" scoped>
.img-box {
  display: flex;
  flex-wrap: wrap;
}

.upload {
  margin: 2px;
  height: 85px;
  position: relative;
}

.upload-img {
  width: 80px;
  height: 85px;
  object-fit: cover;
}

.closeIcon {
  position: absolute;
  right: -5px;
  top: 0;
  cursor: pointer;
}

.upload-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  .delete-icon{
    padding: 10px;
    border-radius: 100px;
    font-size: 20px;
    cursor: pointer;
    background-color: rgba(245, 108, 108, 0.6);
  }
}

.upload-mask-bgColor {
  background-color: rgba(0, 0, 0, 0.5);
}

.upLoad-pic-box {
  .img-box {
    position: relative;
    overflow: hidden;
    border: 1px dotted rgba(0, 0, 0, 1);
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: center;
    align-items: center;

    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .el-icon-plus {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(232, 243, 255);
      padding: 10px;
      border-radius: 100px;
    }
  }
}
</style>
